import axios from 'axios';

export async function getPolicyDetails(dateOfLoss) {
  const requestBody = {
    query: `
      query{
        getPolicyDetails(getPolicyDetailsInput:{dateOfLoss:"${dateOfLoss}"})
      }
      `,
    queryName: 'get_policy_details',
  };

  const response = await axios.post('/api', requestBody);

  return response;
}
